import { Link } from 'react-router-dom';
import './Navbar.css';
import NodeLogo from '../components/Node/NodeLogo';

// Minimal header for public, pre-login pages (privacy, trust, terms) — just the
// logo, linking back to the homepage, reusing the real navbar's look.
function PublicHeader() {
    return (
        <header className="vellby-navbar">
            <Link to="/">
                <NodeLogo size={20} className="navbar-logo" />
            </Link>
        </header>
    );
}

export default PublicHeader;
